export default "__VITE_ASSET__BJyFcq0p__"